<template>
  <div style="height:100%;">
    <!-- 面包屑导航 -->
    <Breadcrumb :levelList="levelList" />
    <div class="aibfb aimt20 pull-left">
      <div class="entity_sysSearchBox pull-right">
        <el-input placeholder="添加关键字"
                  class="selectInput"
                  v-model="entityKeyword"
                  size="medium">
          <svg slot="suffix"
               class="icon"
               aria-hidden="true"
               @click="queryEntityList">
            <use xlink:href="#iconsearchicon" />
          </svg>
        </el-input>
      </div>
    </div>
    <div class="aibfb pull-left aimt10 entity_sysListBox">
      <div v-for="(item,key) in sysEntityList"
           :key="key"
           :class="'entity_sysList' + (item.status === '0' ? ' entity_sysDisable' : '')">
        <div class="entity_sysListTop">
          <div class="entity_sysListImg">
            <img :src="item.iconPath">
          </div>
          <div class="entity_sysListTxt">
            <div class="entity_sysListTxtTitle">{{item.entityName}}</div>
            <div class="entity_sysListTxtcon">{{item.sampleContent}}</div>
          </div>
        </div>
        <div class="entity_sysListBottom">
          <ul>
            <li class="sysentity_status_but">
              <el-tooltip content="测试"
                          placement="bottom"
                          effect="light">
                <span class="iconfont icon-bug"
                      @click="openPredDialog(item.entityTag)"></span>
              </el-tooltip>
            </li>
            <li class="sysentity_status_but">
              <el-tooltip :content="item.status === '0' ? '启用' : '禁用' "
                          placement="bottom"
                          effect="light">
                <span @click="changeStatus(item.status,item.entityTag)"
                      class="iconfont icon-suokai"></span>
              </el-tooltip>
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="aibfb entity_sysfooter">
      <el-button @click="allEnableOrDisable('1')"
                 type="primary"
                 size="small">全部启用</el-button>
      <el-button @click="allEnableOrDisable('0')"
                 type="primary"
                 size="small">全部禁用</el-button>
    </div>
    <el-dialog class="entity_sysDialog"
               title=""
               :visible.sync="dialogTest"
               width="480px">
      <div class="aibfb pull-left entity_sysDialog_title">
        <span>请输入时间：</span><a href="javaScript:;">随机示例</a>
      </div>
      <div class="aibfb pull-left">
        <el-input v-model="predictEntityQuestion"
                  size="small"
                  @keyup.enter.native="predictEntityEnter">
          <el-button slot="append"
                     size="small"
                     @click="predictEntityEnter">发送</el-button>
        </el-input>
      </div>
      <div class="aibfb pull-left aimt10 entity_sysDialog_title">
        <span>分析结果：</span>
      </div>
      <div class="aibfb pull-left entity_sysDialog_card aimb10">
        <!--匹配失败和未匹配‘entity_sysDialog_cardblue’class名称换成‘entity_sysDialog_cardred’class名称-->
        <div class="aibfb pull-left entity_sysDialog_cardblue">
          <span class="icon-pipei iconfont"></span>
          匹配到系统实体
        </div>
        <div class="aibfb pull-left">
          <span v-if="predictEntityList.length > 0">
            <span v-for="(item,index) in predictEntityList"
                  :key="index">
              <span>实体{{index + 1}}：</span>
              <p>{{item}}</p>
              <br />
            </span>
          </span>
          <span v-else>
            <p>{{predictEntityMsg}}</p>
          </span>
        </div>
      </div>
      <div class="clearfix"></div>
    </el-dialog>
  </div>
</template>
<script>
import Breadcrumb from '@/views/components/crm/Breadcrumb'
import { querySysEntityList, disableOrEnableSysEntity, allDisableOrEnableSysEntity, predictEntity } from '@/api/entity-extract/sysEntity.js'
export default {
  components: { Breadcrumb },
  data () {
    return {
      levelList: [{ path: '@/views/entity/system', title: '系统实体' }],
      entityKeyword: '',
      predictEntityQuestion: '',
      predictEntityList: [],
      predictEntityMsg: '',
      dialogTest: false,
      entityTag: '',
      iconImage: {
        Date: 'entity_01',
        BankCard: 'entity_02',
        EMail: 'entity_03',
        Currency: 'entity_04',
        Length: 'entity_05',
        Cellphone: 'entity_06',
        Weight: 'entity_07',
        Telephone: 'entity_08',
        IDCard: 'entity_09',
        Postcode: '',
        Trackingnum: ''
      },
      sysEntityList: []
    }
  },
  mounted: function () {
    this.queryEntityList()
  },
  methods: {
    // 查询实体列表
    queryEntityList () {
      var that = this
      querySysEntityList({ entityKeyword: this.entityKeyword }).then(res => {
        if (res.data.code === 2000) {
          this.sysEntityList = res.data.data
          if (this.sysEntityList) {
            this.sysEntityList.forEach(item => {
              item.iconPath = require('@/assets/images/entity/' + that.iconImage[item.entityTag] + '.png')
            })
          }
        }
      })
    }, // 单个修改实体状态
    changeStatus (status, entityTag) {
      status = status === '0' ? '1' : '0'
      disableOrEnableSysEntity({ status, entityTag }).then(res => {
        if (res.data.code === 2000) {
          window.entityMessage({ type: 'success', text: status === '1' ? '已启用' : '已禁用' })
          this.queryEntityList()
        } else {
          window.entityMessage({ type: 'error', text: res.data.msg })
        }
      }).catch(res => {
        window.entityMessage({ type: 'error', text: res.data.msg })
      })
    }, // 批量修改实体状态
    allEnableOrDisable (status) {
      allDisableOrEnableSysEntity({ status }).then(res => {
        if (res.data.code === 2000) {
          window.entityMessage({ type: 'success', text: status === '1' ? '已全部启用' : '已全部禁用' })
          this.queryEntityList()
        } else {
          window.entityMessage({ type: 'error', text: res.data.msg })
        }
      }).catch(res => {
        window.entityMessage({ type: 'error', text: res.data.msg })
      })
    }, // 预测实体结果
    predictEntityEnter () {
      if (this.predictEntityQuestion.length > 0) {
        predictEntity({ question: this.predictEntityQuestion, entityTag: this.entityTag }).then(res => {
          if (res.data.code === 2000) {
            this.predictEntityList = res.data.data
            if (this.predictEntityList.length === 0) {
              this.predictEntityMsg = '暂未匹配到相关实体'
            }
          } else {
            window.entityMessage({ type: 'error', text: '系统异常' })
          }
        }).catch(res => {
          window.entityMessage({ type: 'error', text: res.data.msg })
        })
      } else {
        window.entityMessage({ type: 'error', text: '问句不能为空' })
      }
    },
    openPredDialog (entityTag) {
      this.dialogTest = true
      this.entityTag = entityTag
      this.predictEntityMsg = ''
      this.predictEntityQuestion = ''
      this.predictEntityList = []
    }
  }
}
</script>
<style lang="scss" scoped>
.sysentity_status_but {
  cursor: pointer !important;
}
</style>
